var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help"},[_c('Nav'),_c('div',{staticClass:"banner"}),_vm._m(0),_c('Bottom')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help_cen"},[_c('div',{staticClass:"imgbox"},[_c('img',{attrs:{"src":require("../../assets/images/404.png"),"alt":""}})]),_c('div',{staticClass:"text"},[_vm._v("2022年沪惠保投保通道关闭")])])
}]

export { render, staticRenderFns }